class CartUpsellAddToCart extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
      this.closest('.cart-upsell__product-card')?.addEventListener(
        'cart-upsell:variant-changed',
        this.#handleVariantChange
      );
    }
  
    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
      this.closest('.cart-upsell__product-card')?.removeEventListener(
        'cart-upsell:variant-changed',
        this.#handleVariantChange
      );
    }
  
    #handleVariantChange = (event) => {
      const { variant } = event.detail;
      if (!variant) return;
      this.dataset.variantId = variant.id;
    };
  
    #handleClick = async (event) => {
      const button = event.target.closest('button[name="add"]');
      if (!button || button.disabled) return;
  
      const variantId = this.dataset.variantId;
      if (!variantId) return;
  
      // Trigger animation immediately on click, decoupled from the fetch
      this.querySelector('add-to-cart-component')?.animateAddToCart();
  
      const cartItemsComponent = document.querySelector('cart-items-component');
      const sectionId = cartItemsComponent?.dataset.sectionId;
  
      const body = { id: variantId, quantity: 1 };
      if (sectionId) {
        body.sections = sectionId;
        body.sections_url = window.location.pathname;
      }
  
      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
  
        if (!addResponse.ok) {
          const data = await addResponse.json();
          throw new Error(data.description || data.message || addResponse.statusText);
        }
  
        const addData = await addResponse.json();
        const cart = await fetch('/cart.js').then((r) => r.json());
  
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'cart-upsell-add-to-cart',
              data: {
                source: 'cart-upsell',
                variantId,
                productId: this.dataset.productId,
                itemCount: cart.item_count,
                sections: addData.sections ?? {},
              },
            },
          })
        );
      } catch (error) {
        console.error('[CartUpsellAddToCart]', error);
      }
    };
  }
  
  if (!customElements.get('cart-upsell-add-to-cart')) {
    customElements.define('cart-upsell-add-to-cart', CartUpsellAddToCart);
  }